var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlockPotential = function SvgUnlockPotential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M67 36V17a8 8 0 0 0-8-8v0a8 8 0 0 0-8 8v19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M17.333 32.667c-.598-5.78-1.179-8.675-2.919-10.415S9.78 19.932 4 19.333c5.78-.598 8.674-1.179 10.414-2.919S16.734 11.78 17.334 6c.598 5.78 1.178 8.674 2.918 10.414s4.635 2.32 10.415 2.92c-5.78.598-8.675 1.178-10.415 2.918s-2.32 4.635-2.919 10.415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M37.333 21.333c-.3-2.89-.59-4.337-1.46-5.207s-2.317-1.16-5.206-1.46c2.89-.299 4.337-.589 5.207-1.459s1.16-2.318 1.46-5.207c.299 2.89.589 4.337 1.459 5.207s2.317 1.16 5.207 1.46c-2.89.299-4.337.59-5.207 1.459s-1.16 2.318-1.46 5.207M26.667 8c-.18-1.734-.354-2.602-.876-3.124S24.401 4.18 22.667 4c1.733-.18 2.602-.354 3.124-.876s.696-1.39.876-3.124c.18 1.734.353 2.602.875 3.124s1.39.696 3.125.876c-1.734.18-2.603.354-3.125.876s-.696 1.39-.875 3.124"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M11.149 35.472a3 3 0 0 0-3 3V62a8 8 0 0 0 8 8h35.793a8 8 0 0 0 8-8V38.472a3 3 0 0 0-3-3zm30.377 13.811a6.9 6.9 0 0 1-3.453 5.982v4.377a3.453 3.453 0 1 1-6.905 0v-4.377a6.906 6.906 0 1 1 10.359-5.982",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M38.074 55.265a6.906 6.906 0 1 0-6.906 0v4.377a3.453 3.453 0 1 0 6.906 0z",
    clipRule: "evenodd"
  })));
};
export default SvgUnlockPotential;